<template>
    <div >
        <label class="is-size-4 mb-1">
            {{ translatedLabel }}
        </label>
        <v-text-field
            v-mask="mask"
            v-model="fieldValue"
            :key="updateKey"
            :autofocus="autofocus"
            :placeholder="placeholder || virtualPlaceholder"
            :type="type"
            :solo="!translatedFieldLabel"
            :label="translatedFieldLabel"
            flat
            :outlined="outlined"
            :hide-details="$isMobile ? 'auto' : false"
            
            background-color="white"
            validate-on-blur
            :rules="rules"
            :error.sync="hasError"
            :disabled="isDisabled"
            :autocomplete="autocomplete"
            @keydown="onKeydown"
            @blur="onBlur"
            @focus="$emit('focus')"
            
            :style="{'height': fieldHeight}"
            :height="fieldHeight"
            >
            <template #append>
                <span
                    class="textSecondary--text mt-2"
                    style="width: max-content"
                    >
                    {{ appendText }}
                </span>

                <v-tooltip 
                    v-if="tooltip"
                    color="blue" 
                    top
                    >
                    <template v-slot:activator="{ on, attrs }">
                        <div v-on="on" v-bind="attrs">
                            <svg
                                class="tooltip-icon"
                                width="26"
                                height="24"
                                viewBox="0 0 26 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <rect
                                    x="0.5"
                                    y="0.5"
                                    width="25"
                                    height="23"
                                    rx="11.5"
                                    stroke="#6AC7EE"
                                />
                                <path
                                    d="M13.249 14.573C13.2363 14.7123 13.1983 14.8073 13.135 14.858C13.0843 14.896 12.9703 14.915 12.793 14.915H12.356C12.1153 14.915 11.9887 14.82 11.976 14.63L11.558 6.042C11.5453 5.966 11.5643 5.89 11.615 5.814C11.6657 5.738 11.7543 5.7 11.881 5.7H13.325C13.4643 5.7 13.5593 5.738 13.61 5.814C13.6607 5.89 13.6797 5.966 13.667 6.042L13.249 14.573ZM14.028 17.765C14.028 18.1577 13.895 18.4933 13.629 18.772C13.363 19.038 13.0273 19.171 12.622 19.171C12.2167 19.171 11.881 19.038 11.615 18.772C11.349 18.506 11.216 18.1703 11.216 17.765C11.216 17.3723 11.349 17.043 11.615 16.777C11.8937 16.4983 12.2293 16.359 12.622 16.359C13.0273 16.359 13.363 16.492 13.629 16.758C13.895 17.024 14.028 17.3597 14.028 17.765Z"
                                    fill="#6AC7EE"
                                />
                            </svg>
                        </div>
                    </template>
                    <span class="is-size-5 d-block">{{ tooltip.text }}</span>
                </v-tooltip>
            </template>
        </v-text-field>

        <label class="is-size-5">
            {{ comment }}
        </label>
    </div>
</template>

<script>
import { replaceToCyrilic } from '@/helpers/replaceToCyrylic';

export default {
    props: {
        value: [Number, String, Boolean],
        fieldHeight: String,
        // forceValue: [Number, String, Boolean],
        label: String,
        comment: String,
        labelTranslate: String,
        append: String,
        mask: String,
        type: String,
        rules: Array,
        placeholder: String,
        outlined: Boolean,
        fieldLabel: String,
        tooltip: Object,
        // {
        //     type: Boolean,
        //     default: false
        // },
        disabled: Boolean,
        replaceEngToRu: {
            type: Boolean,
            default: true,
        },
        // Ограничения ввода:
        isMoney: Boolean,
        isCyrilic: Boolean,
        isCyrilicIssued: Boolean,
        isCyrilicPlace: Boolean,
        isEngEmail: Boolean,
        autocomplete: String,
    },
    // mounted() {
    //     if (this.forceValue) {
    //         this.fieldValue = this.forceValue;
    //     }
    // },
    // watch: {
    //     forceValue(val) {
    //         this.fieldValue = this.forceValue;
    //     }
    // },
    computed: {
        fieldValue: {
            get() {
                if (this.isMoney && this.value) {
                    return this.value
                        .toString()
                        .replace(/(\d)(?=(\d{3})+([^\d]|$))/g, '$1 ');
                } else {
                    return this.value;
                }
            },
            set(val) {
                let oldval = val;

                if (val != this.value) {
                    // Применяем ограничения ввода
                    val = this.applyInputRestrictions(val);

                    this.$emit('input', val);

                    if (val != oldval) {
                        // перерисовка позволяет видеть в поле ввод с ограничениями
                        this.updateKey++;
                        // autofocus позволяет мобильной клавиатуре оставаться на месте
                        // при перерисовке поля по updateKey
                        this.autofocus = true;
                    } else {
                        this.autofocus = false;
                    }
                }
            },
        },
        translatedLabel() {
            return this.$t(this.labelTranslate) || this.label;
        },
        translatedFieldLabel() {
            return this.$t(this.fieldLabel) || this.fieldLabel;
        },
        appendText() {
            return this.append;
        },
        virtualPlaceholder() {
            if (this.mask) {
                return this.mask.replace(/#/g, '0');
            } else {
                return null;
            }
        },
        isDisabled() {
            return this.disabled;
        },
    },
    data() {
        return {
            updateKey: 0,
            autofocus: false,
            hasError: false,
        };
    },
    methods: {
        applyInputRestrictions(val) {
            let oldval = val;
            let key;

            if (this.isMoney) {
                val = val.replace(/\D/g, '');
            }
            if (this.isEngEmail) {
                val = val.replace(/[^a-zA-Z\-0-9.@]/g, '');
            }
            if (this.isCyrilic) {
                val = val.replace(/[^а-яА-ЯёЁ -]/g, '');
            }
            if (this.isCyrilicIssued) {
                val = val.replace(/[^0-9А-яЁё/\\(№\-.,")\s]/g, '');
            }
            if (this.isCyrilicPlace) {
                val = val.replace(/[^0-9А-яЁё("\-.)\s]/g, '');
            }
            if (this.replaceEngToRu) {
                key = oldval.replace(val, '');
                if (key.length == 1) {
                    val += replaceToCyrilic(key);
                }
            }
            return val;
        },
        onKeydown(e) {
            // У keydown плохая совместимость
            // с мобильными браузерами на сентябрь 2021
            // в event.key не приходит значение
            this.$emit('keydown', e);
        },
        onBlur(e) {
            this.$emit('blur', e);
        },
    },
};
</script>
